exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/corporate/confidentiality/confidentiality.component.css
// module id = ../../../../../src/app/corporate/confidentiality/confidentiality.component.css
// module chunks = main